export default "__VITE_ASSET__DgJJsEDd__"